<template>
  <div>
    <v-col cols="12">
      <v-row style="padding: 1%" justify="end">
        <v-col cols="12" sm="12" md="2">
          <v-btn @click="goBack()" flat class="back-btn">Back</v-btn>
        </v-col>
      </v-row>
      <v-row style="padding: 2%" justify="center" align="center">
        <div class="card1">Message User</div>
        <div class="card">
          <v-col cols="12" sm="12" md="7" style="padding: 2%">
            <div class="headers">Title</div>
            <v-text-field
              solo
              dense
              outlined
              placeholder="Important message ect.."
              v-model="title"
            >
            </v-text-field>
            <div class="headers">Message Details</div>
            <v-textarea
              v-model="message"
              solo
              outlined
              placeholder=""
              height="200px"
            >
            </v-textarea>
          </v-col>
        </div>
      </v-row>
      <v-row style="padding: 1%; margin-top: -2%">
        <v-col cols="12" sm="3" md="3">
          <v-btn
            class="btn send-btn"
            dark
            @click="messagingUser = true"
            v-if="message && title"
            >Send Message</v-btn
          >
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-alert
          v-if="success"
          style="position: absolute; top: 50%"
          type="success"
          >{{ successMessage }}</v-alert
        >
        <v-alert
          v-if="error"
          style="position: absolute; top: 50%"
          type="error"
          >{{ errorMessage }}</v-alert
        >
      </v-row>
    </v-col>
    <v-dialog
      v-model="messagingUser"
      v-if="messagingUser"
      width="500px"
      height="500px"
    >
      <v-col cols="12" sm="12" md="12">
        <v-row justify="center" align="center">
          <div class="popup-heading-text">
            Would you like to send this message?
          </div>
          <v-btn class="black--text cancel-btn" @click="messagingUser = false">
            Cancel
          </v-btn>
          <v-btn
            class="btn save-btn"
            dark
            @click="
              sendNotification();
              loading();
            "
          >
            Save
          </v-btn>
        </v-row>
        <v-row> </v-row>
      </v-col>
    </v-dialog>
    <v-row justify="center">
      <v-overlay :value="loading" style="z-index: 999">
        <v-progress-circular
          :size="100"
          color="##008080"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-row>
  </div>
</template>

<script >
import Navbar from "@/components/Navbar";

import {
  collection,
  getDocs,
  getFirestore,
  where,
  setDoc,
  doc,
  query,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  name: "App",
  components: { Navbar },
  methods: {
    goToPage(path) {
      this.$router.push({ path });
    },
    goBack() {
      this.$router.push({ path: "/users", query: { type: "Dashboard" } });
    },
    openSaveDialog() {
      this.savingUser = !this.savingUser;
    },
  },
  data() {
    return {
      savingUser: false,
      loading: false,
      user: null,
      title: "",
      message: "",
      error: false,
      success: false,
      errorMessage: "Something went wrong, please try again",
      successMessage: "Success",
      messagingUser: false,
      userToken: null,
    };
  },
  methods: {
    // Log the message event to Audit Trail in Firestore
    async logMessageEvent() {
      let newEvent = {
        date: Math.floor(new Date().getTime() / 1000),
        eventType: "Message Sent",
        eventAction: "Message Sent",
        user: localStorage.getItem("mobile"),
      };

      await addDoc(collection(db, "events"), newEvent)
        .then(async (res) => {})
        .catch((error) => {
          console.log(error);
        });
    },
    // Fetch the user's token to send a message
    async getUserToken() {
      let q = query(
        collection(db, "fcmToken"),
        where("mobile", "==", this.user.mobile)
      );

      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        this.userToken = doc.data().token;

        console.log(doc.data());
      });
    },
    // Method to send the message to tthe user
    sendNotification() {
      if (!this.title || !this.message) {
        this.messagingUser = false;
        let that = this;
        this.error = true;
        this.errorMessage = "Please provide a title & a message!";

        setTimeout(function () {
          that.error = false;
        }, 2000);
        return;
      }

      if (!this.userToken) {
        this.messagingUser = false;
        let that = this;
        this.error = true;
        this.errorMessage = "Could not find the FCM Token for this user!";

        setTimeout(function () {
          that.error = false;
        }, 2000);

        return;
      }

      let body = JSON.stringify({
        data: {
          token: this.userToken,
          title: this.title,
          message: this.message,
        },
      });
      this.loading = true;
      fetch(
        "https://europe-west2-propertygroupapp.cloudfunctions.net/sendUserPushNotification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: body,
        }
      )
        .then((response) => {
          this.messagingUser = false;
          response.json();
        })
        .then((response) => {
          console.log(JSON.stringify(response));
          this.postMessage();
          this.logMessageEvent();
          this.loading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.messagingUser = false;
          let that = this;
          this.error = true;
          this.errorMessage = "Unable to message user, please try again!";

          setTimeout(function () {
            that.error = false;
          }, 2000);
        });
    },
    // Method to navigate to the previous page
    goBack() {
      let userType = localStorage.getItem("userType");

      if (userType == "App") {
        this.$router.push({ path: "/users", query: { type: "App" } });
      } else if (userType == "Dashboard") {
        this.$router.push({ path: "/users", query: { type: "Dashboard" } });
      }
    },
    // Method to log the message in Messages in Firestore
    async postMessage() {
      let newMessage = {
        userID: this.user.id,
        token: this.userToken,
        mobile: this.user.mobile,
        title: this.title,
        message: this.message,
      };

      await addDoc(collection(db, "messages"), newMessage)
        .then((res) => {
          console.log("res: ", res);

          this.title = "";
          this.message = "";
          this.messagingUser = false;
          let that = this;
          this.success = true;
          this.successMessage = "Successfully messaged user!";

          setTimeout(function () {
            that.success = false;
          }, 2000);

          console.log("res: ", res);
        })
        .catch((error) => {
          console.log(error);
          let that = this;
          this.error = true;
          this.errorMessage = "Unable to message user, please try again!";

          setTimeout(function () {
            that.error = false;
          }, 2000);
        });
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("viewedUser"));
    console.log("User: ", this.user);
    this.getUserToken();
  },
};
</script>

<style scoped>
.cancel-btn {
  box-shadow: 0px 0px 0px 1px black;
  border-radius: 20px;
  width: 40%;
  margin-top: -15%;
}

.send-btn {
  background: rgb(34, 193, 195);
  background: linear-gradient(
    0deg,
    rgba(34, 193, 195, 1) 0%,
    rgba(0,129,128,255) 100%
  );
  border-radius: 20px;
  width: 100%;
}

.back-btn {
  border-radius: 15px;
  width: 100%;
  box-shadow: 0px 0px 0px 1px black;
  background-color: white;
}

.popup-heading-text {
  background-color: white;
  width: 100%;
  height: 300px;
  font-size: 18px;
  font-weight: bold;
  padding: 20%;
  white-space: nowrap;
}

.card1 {
  box-shadow: 0px 0px 0px 1px black;
  background-color: black;
  /* height:50px; */
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  color: white;
  text-align: center;
  padding: 15px;
  margin-top: -3%;
}

.save-btn {
  background: linear-gradient(
    0deg,
    rgba(34, 193, 195, 1) 0%,
    rgba(0,129,128,255) 100%
  );
  border-radius: 20px;
  width: 40%;
  margin-top: -15%;
  white-space: nowrap;
}

.card {
  box-shadow: 0px 0px 0px 1px black;
  height: 450px;
  width: 100%;
  border-radius: 0px 0px 12px 12px;
  text-align: center;
  margin-top: -1%;
}

.headers {
  text-align: left;
}

.v-text-field {
  min-height: "20px";
  height: 65px;
}

.v-btn {
  margin-left: 2%;
}

.btn {
  background: linear-gradient(
    0deg,
    rgba(34, 193, 195, 1) 0%,
    rgba(0,129,128,255) 100%
  );
}
</style>